import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, FormArray, Form } from "@angular/forms";
import { Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment-timezone";
import { data } from "jquery";
import { AuthService } from "../../../service/auth-service/auth.service";
import {
  imageProcessing,
  ImageSnippet,
} from "../../../utils/image-processing-utils";
import { sweetAlert } from "../../../utils/swal";
import { StaffService } from "../staff-service/staff.service";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { nonZeroCoordinateValidator } from "src/app/utils/utils.common";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
@Component({
  selector: "app-staffs-create",
  templateUrl: "./staffs-create.component.html",
  styleUrls: ["./staffs-create.component.css"],
})
export class StaffsCreateComponent implements OnInit {
  addNewStaff: FormGroup;
  submitted = false;
  btnName = "Create";
  selectedFile: ImageSnippet = null;
  profileImageURL = null;
  userId = null;
  staffUserId = "";
  passwordToggleFlag = true;
  user;
  allowStaffShift = false;
  days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  constructor(
    private sharedDataService: SharedDataService,
    public authService: AuthService,
    private staffService: StaffService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.params
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((params) => {
        this.staffUserId = params["id"];
      });

    this.addNewStaff = this.fb.group({
      displayName: ["", [Validators.required, Validators.minLength(3)]],
      contactNumber: ["", Validators.required],
      address: ["", Validators.required],
      roles: ["", Validators.required],
      accountStatus: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required, Validators.minLength(3), Validators.maxLength(16)]],
      latitude: ["", [Validators.required, nonZeroCoordinateValidator()]],
      longitude: ["", [Validators.required, nonZeroCoordinateValidator()]],
      staffId: [""],
      images: [""],
      isLocked: [false],
      isShift: [false],
      shifts: this.fb.array([]),
    });
    this.addPreShifts();
    this.getUser();
  }

   getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          if (this.user && this.user.hasOwnProperty('isStaffShift')) {
            this.allowStaffShift = this.user.isStaffShift;
          }
           this.fillForm();
        }
      });
  }

  fillForm() {
    if (this.staffUserId) {
      this.addNewStaff.get('password').clearValidators();

      this.staffService.getStaffById(this.staffUserId)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(
          (data) => {
            if (data) {
              this.addNewStaff.patchValue({ ...data, password: "" });
              this.profileImageURL = data.profileImageURL;
              if (data.shifts) {
                this.updateShift(data.shifts);
              }
            }
          },
          (err) => {
            sweetAlert("Error", err, "error", "Ok");
            this.router.navigateByUrl("staff");
          }
        );
    } else {
      this.addNewStaff.get('password').setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(16)],);
    }
    this.addNewStaff.get('password').updateValueAndValidity();
  }

  processFile(imageInput: any) {
    imageProcessing(imageInput)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((result) => {
        this.selectedFile = result.file;
        this.profileImageURL = result.src;
      });
  }

  getAddress(place) {
    this.addNewStaff.patchValue({
      address: place.formatted_address,
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
    });
  }

  togglePasswordType() {
    this.passwordToggleFlag = !this.passwordToggleFlag;
  }

  saveStaff() {
    this.submitted = true;
    if (this.addNewStaff.invalid) {
      return;
    } else if (this.allowStaffShift && this.addNewStaff.value.isShift && !this.singleDayShift()) {
      return;
    } else if (this.selectedFile == null && this.profileImageURL == null) {
      return;
    } else {
      const image = {
        newProfilePicture: this.selectedFile,
      };

      if (this.staffUserId) {
        this.addNewStaff.patchValue({
          staffId: this.staffUserId,
          images: image,
        });

      } else {
        this.addNewStaff.patchValue({
          images: image,
        });
      }

      const payload = { ...this.addNewStaff.value };

      if(this.user && this.user.sRoles){
        payload.isLocked = this.user.isLocked
      }

      if (this.staffUserId) {
        if (!this.addNewStaff.value.password) {
          delete payload.password;
        }
      }

      if (payload.shifts && payload.shifts.length) {
        payload.shifts = payload.shifts.map((shift) => ({
          checkin: shift.checkin,
          checkout: shift.checkout,
          shiftAlign: shift.shiftAlign,
          day: shift.day,
          isEnabled: shift.isEnabled,
        }));
      }

      this.staffService.saveStaff(payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(
          (data) => {
            if (data) {
              this.router.navigateByUrl("staff");
            }
          },
          (err) => {
            sweetAlert("Error", err, "error", "Ok");
          }
        );
    }
  }

  get form() {
    return this.addNewStaff.controls;
  }


  toggleLock() {
    this.addNewStaff.patchValue({
      isLocked: !this.addNewStaff.value.isLocked
    });
  }

  toggleStaffShift() {
    this.addNewStaff.patchValue({
      isShift: !this.addNewStaff.value.isShift
    });
  }

  ngOnDestroy(): void {
  }

  addPreShifts() {
    const items = this.addNewStaff.get('shifts') as FormArray;
    for (const day of [0, 1, 2, 3, 4, 5, 6]) {
      items.push(
        this.fb.group({
          perCheckin: [moment().startOf('day')],
          preCheckout: [moment().endOf('day')],
          checkin: [moment().startOf('day').format("HH:mm"), Validators.required],
          checkout: [moment().endOf('day').format("HH:mm"), Validators.required],
          shiftAlign: ['opener', Validators.required],
          day: [day, Validators.required],
          isEnabled: [false]
        })
      );
    }
  }

  updateShift(preShifts?) {
    const items = this.addNewStaff.get('shifts') as FormArray;
    if (preShifts && preShifts.length) {
      for (let shift of preShifts) {
        const item = items.controls.find(c => c.value.day === shift.day);
        if (item) {
          const checkinParts = shift.checkin ? shift.checkin.split(":") : ["00", "00"];
          const checkoutParts = shift.checkout ? shift.checkout.split(":") : ["23", "59"];
          item.patchValue({
            perCheckin: moment().startOf('day').hours(Number(checkinParts[0])).minutes(Number(checkinParts[1])).seconds(0),
            preCheckout: moment().startOf('day').hours(Number(checkoutParts[0])).minutes(Number(checkoutParts[1])).seconds(0),
            checkin: moment().startOf('day').hours(Number(checkinParts[0])).minutes(Number(checkinParts[1])).seconds(0).format("HH:mm"),
            checkout: moment().startOf('day').hours(Number(checkoutParts[0])).minutes(Number(checkoutParts[1])).seconds(0).format("HH:mm"),
            shiftAlign: shift.shiftAlign || 'opener',
            day: shift.day,
            isEnabled: shift.isEnabled || false
          });
        }
      }
    }
  }

  onChangeShiftStart(evt, shift) {
    shift.patchValue({
      checkin: moment(evt).format("HH:mm")
    });

    if (shift.controls.perCheckin.value.isAfter(shift.controls.preCheckout.value)) {
      shift.patchValue({
        preCheckout: moment(evt),
        checkout: moment(evt).format("HH:mm")
      });
    }
  }

  onChangeShiftEnd(evt, shift) {
    shift.patchValue({
      checkout: moment(evt).format("HH:mm")
    });

    if (shift.controls.perCheckin.value.isAfter(shift.controls.preCheckout.value)) {
      shift.patchValue({
        preCheckin: moment(evt),
        checkin: moment(evt).format("HH:mm")
      });
    }
  }

  getMinDate() {
    return moment().startOf('day');
  }

  getMaxDate() {
    return moment().endOf('day');
  }

  getStartMinDate(val) {
    return moment(val);
  }

  get shiftsForm() {
    return this.addNewStaff.get('shifts') as FormArray;
  }

  singleDayShift() {
    let isDayShiftEnabled = false;
    if (this.addNewStaff.value.shifts) {
      for (let item of this.addNewStaff.value.shifts) {
        if (item.isEnabled) {
          isDayShiftEnabled = true;
          break;
        }
      }
    }
    return isDayShiftEnabled;
  }
}
